import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'next-i18next';
import { useFormikContext } from 'formik';

import Button, { BUTTON_VARIANTS } from '@common/components/Button';

const SubmitButton = ({ canSubmit }) => {
  const { t } = useTranslation();
  const { isValid } = useFormikContext();

  return (
    <Button
      type="submit"
      variant={BUTTON_VARIANTS.LEVEL_1_GREEN}
      disabled={!canSubmit || !isValid}
    >
      {t('global.form.button.nextStep', 'Nächster Schritt')}
    </Button>
  );
};

SubmitButton.propTypes = {
  canSubmit: PropTypes.bool.isRequired,
};

export default SubmitButton;
